import * as React from 'react';
import {enhance} from './enhancer';
import {Link} from 'react-router-dom';
import Table from '@/migration/table/Table';
import {Field} from 'redux-form';
import {Search} from '@/migration/search';
import {Icon} from 'semantic-ui-react';
import {SalesTableColumns} from './../../../components/DummySales';
import {config} from './../../../config';
import {lifecycle} from './lifecycle';
import {setState} from './state';
import {handler} from './handler';

import './index.scss';

function UsersMain(props: any) {
  const state = setState();
  const {paths} = config;
  lifecycle.componentDidMount(state, props);

  return (
    <div className="a__sales-main">
      <div className="b__title c__after-title">
        <h1 style={{fontFamily: 'UD Shin Go Medium'}}> ダミー出品商品 </h1>
      </div>
      <div className="b__sub">
        <div className="b__search">
          <Field
            name="searchWord"
            component={Search}
            placeholder="検索ワードを入力"
            addSearchWord={handler.addSearchWord(state, props)}
            searchWords={props.sales.searchWords}
            removeSearchWord={handler.removeSearchWord(state, props)}
            outline
          />
        </div>
        <div className="b__create">
          <Link to={paths.dummySales.create}>
            <span>
              <Icon name="add" />
              ダミー出品商品を作成する
            </span>
          </Link>
        </div>{' '}
      </div>

      <div className="b__sales">
        <Table
          active={props.sales.pages.active}
          columns={SalesTableColumns(props)}
          current={props.sales.current}
          totalCount={props.sales.totalCount}
          loading={state.loading || props.sales.loading}
          updateCurrent={handler.updateCurrent(state, props)}
          disabled={state.disabled}
          sortState={props.sales.sortState}
          updateSortState={handler.updateSortState(state, props)}
          pageSize={50}
        />
      </div>
    </div>
  );
}

export default enhance((props: any) => <UsersMain {...props} />);
